// src/routes/(app)/(platform)/(videos)/videos/+layout.ts
import type { LayoutLoad } from './$types';
import { getPlaylists } from '$lib/services/playlists';
import { getPage } from '$lib/services/page';
import { getVideos, getVideoSectors } from '$lib/services/videos';

export const load: LayoutLoad = async ({ params, parent, url }) => {
	const { balancedSupabase, user } = await parent();

	const pageNumber = parseInt(url.searchParams.get('page') || '1');
	const pageSize = 24;
	const start: number = (pageNumber - 1) * pageSize;
	const end: number = pageNumber * pageSize - 1;

	const [page, sectors] = await Promise.all([
		getPage(balancedSupabase, '67f515c3-ac69-479f-a543-87555e97b25f'),
		getVideoSectors(balancedSupabase)
	]);

	return {
		videos: getVideos(balancedSupabase, user, url, params, start, end),
		sectors,
		page
	};
};
